import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'
import { IntermediateNodeWithConditionalsAndOutputs } from '../presentationToConductorWorkflow/presentationToConductorWorkflow.types'

export const getValidVariants = ({
  upstreamNodes,
  variantNodeTypes,
  definitions
}: {
  upstreamNodes: IntermediateNodeWithConditionalsAndOutputs[]
  variantNodeTypes: NodeType[]
  definitions: ResolvedNodeDefinitions
}): NodeType[] => {
  if (upstreamNodes.length === 0) return []

  return variantNodeTypes.filter(nodeType => {
    const definition = definitions[nodeType]
    if (!definition?.inputMapping) return false

    try {
      definition.inputMapping({
        upstreamNodes,
        config: definition.defaultConfig
      })
      return true
    } catch {
      return false
    }
  })
}
